import api from '../utils/api';

const subscriberApi = {
    registerDevice: (data) => {
        return new Promise((resolve, reject) => {
            return api
                .post('/v1/admin/subscriber', data, {
                    headers: { Scope: 'network' }
                })
                .then((res) => resolve(res.data))
                .catch((error) => {
                    // Log lỗi
                    console.error('Register device error:', error?.data || error);
                    reject(error);
                });
        });
    },
    getAll: (params) => {
        return new Promise((resolve, reject) => {
            api.get('/v1/admin/subscriber', { params })
                .then((res) => resolve(res.data))
                .catch(reject);
        });
    },
    get: (id) => {
        return new Promise((resolve, reject) => {
            api.get(`/v1/admin/subscriber/${id}`)
                .then((res) => resolve(res.data))
                .catch(reject);
        });
    },
    update: (id, data) => {
        return new Promise((resolve, reject) => {
            api.put(`/v1/admin/subscriber/${id}`, data)
                .then((res) => resolve(res.data))
                .catch(reject);
        });
    },
    delete: (device_id) => {
        return new Promise((resolve, reject) => {
            api.delete(`/v1/admin/subscriber/device/${device_id}`)
                .then((res) => resolve(res.data))
                .catch(reject);
        });
    },
    getCount: (params) => {
        return new Promise((resolve, reject) => {
            api.get('/v1/admin/subscriber/count', {
                params,
                headers: { Scope: 'network' }
            })
                .then((res) => resolve(res.data))
                .catch(reject);
        });
    },
};

export default subscriberApi; 